import React, { useState } from 'react'
import styled from 'styled-components'
import Dropdown from '../../assets/dropdown.svg'

import { desktopVw } from '../../styles/utils'

import styles from '../../templates/faq-page.module.scss'
import classNames from 'classnames'
const Container = styled.div``
const ContentWrapper = styled.div`
  width: 100%;
`

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-family: ${props => props?.theme?.fonts?.grosa};
  font-size: 13px;
  line-height: 19px;

  @media (min-width: ${props => props?.theme?.breakpoints?.desktopSmall}px) {
    font-size: ${desktopVw(16)};
    line-height: ${desktopVw(22)};

    svg {
      height: ${desktopVw(16)};
      width: ${desktopVw(16)};
    }
  }
`
const IconWrapper = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  transform: ${props => (props?.reverse ? 'rotate(180deg)' : 'none')};
  cursor: pointer;

  svg {
    margin-top: 7px;
    height: 13px;
    width: 15px;
  }
`
const Collapsible = ({ children, title, onCollapsed, startCollapsed, className }) => {
  const [collapsed, setCollapsed] = useState(startCollapsed)

  const toggle = () => {
    setCollapsed(!collapsed)
    if (onCollapsed && typeof onCollapsed === 'function') {
      onCollapsed(!collapsed)
    }
  }

  return (
    <Container className={classNames(styles.collapsibleContainer, className)}>
      <HeaderWrapper onClick={toggle} className={styles.collapsibleHeader}>
        {title}
        <IconWrapper reverse={!collapsed}>
          {/* <Dropdown class={!collapsed && `reversed`} /> */}
          <Dropdown />
        </IconWrapper>
      </HeaderWrapper>
      {!collapsed && <ContentWrapper className={styles.collapsibleContent}>{children}</ContentWrapper>}
    </Container>
  )
}

export default Collapsible
